// extracted by mini-css-extract-plugin
export var calendarView = "_kf-0";